"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setTreemapUiConfig = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2021 GoodData Corporation
var cloneDeep_1 = tslib_1.__importDefault(require("lodash/cloneDeep"));
var set_1 = tslib_1.__importDefault(require("lodash/set"));
var forEach_1 = tslib_1.__importDefault(require("lodash/forEach"));
var sdk_ui_1 = require("@gooddata/sdk-ui");
var uiConfig_1 = require("../../constants/uiConfig");
var bucket_1 = require("../../constants/bucket");
var bucketRules_1 = require("../bucketRules");
var bucketHelper_1 = require("../bucketHelper");
var translations_1 = require("../translations");
var bucket_title_measures_svg_1 = tslib_1.__importDefault(require("../../assets/treemap/bucket-title-measures.svg"));
var bucket_title_view_svg_1 = tslib_1.__importDefault(require("../../assets/treemap/bucket-title-view.svg"));
var bucket_title_segment_svg_1 = tslib_1.__importDefault(require("../../assets/treemap/bucket-title-segment.svg"));
var baseChartUiConfigHelper_1 = require("./baseChartUiConfigHelper");
function setTreemapBucketWarningMessages(referencePoint, intl) {
    var buckets = (referencePoint === null || referencePoint === void 0 ? void 0 : referencePoint.buckets) || [];
    var updatedUiConfig = cloneDeep_1.default(referencePoint === null || referencePoint === void 0 ? void 0 : referencePoint.uiConfig);
    var viewItems = bucketHelper_1.getViewItems(buckets, [bucket_1.ATTRIBUTE, bucket_1.DATE]);
    forEach_1.default(buckets, function (bucket) {
        var _a, _b;
        var localIdentifier = (_a = bucket === null || bucket === void 0 ? void 0 : bucket.localIdentifier) !== null && _a !== void 0 ? _a : "";
        var bucketUiConfig = (_b = updatedUiConfig === null || updatedUiConfig === void 0 ? void 0 : updatedUiConfig.buckets) === null || _b === void 0 ? void 0 : _b[localIdentifier];
        // skip disabled buckets
        if (!(bucketUiConfig === null || bucketUiConfig === void 0 ? void 0 : bucketUiConfig.enabled)) {
            return;
        }
        if (!(bucketUiConfig === null || bucketUiConfig === void 0 ? void 0 : bucketUiConfig.canAddItems)) {
            var warningMessage = void 0;
            if (bucket.localIdentifier === sdk_ui_1.BucketNames.MEASURES) {
                warningMessage = baseChartUiConfigHelper_1.getBucketItemsWarningMessage("dashboard.bucket.metric_view_by_warning", intl, viewItems);
            }
            if (bucket.localIdentifier === sdk_ui_1.BucketNames.VIEW) {
                warningMessage = translations_1.getTranslation("dashboard.bucket.category_category_by_warning", intl);
            }
            if (bucket.localIdentifier === sdk_ui_1.BucketNames.SEGMENT) {
                warningMessage = translations_1.getTranslation("dashboard.bucket.category_segment_by_warning", intl);
            }
            if (warningMessage) {
                set_1.default(updatedUiConfig, [bucket_1.BUCKETS, localIdentifier, "warningMessage"], warningMessage);
            }
        }
    });
    return updatedUiConfig;
}
function setTreemapUiConfig(referencePoint, intl, visualizationType) {
    var _a;
    var referencePointConfigured = cloneDeep_1.default(referencePoint);
    var buckets = (_a = referencePointConfigured === null || referencePointConfigured === void 0 ? void 0 : referencePointConfigured.buckets) !== null && _a !== void 0 ? _a : [];
    var measuresCanAddItems = !bucketRules_1.hasOneCategory(buckets) || bucketRules_1.hasNoMeasures(buckets);
    var viewCanAddItems = !bucketRules_1.hasMoreThanOneMasterMeasure(buckets, sdk_ui_1.BucketNames.MEASURES);
    set_1.default(referencePointConfigured, uiConfig_1.UICONFIG, bucketHelper_1.setBucketTitles(referencePoint, visualizationType, intl));
    set_1.default(referencePointConfigured, [uiConfig_1.UICONFIG, bucket_1.BUCKETS, sdk_ui_1.BucketNames.MEASURES, "canAddItems"], measuresCanAddItems);
    set_1.default(referencePointConfigured, [uiConfig_1.UICONFIG, bucket_1.BUCKETS, sdk_ui_1.BucketNames.VIEW, "canAddItems"], viewCanAddItems);
    set_1.default(referencePointConfigured, [uiConfig_1.UICONFIG, bucket_1.BUCKETS, sdk_ui_1.BucketNames.SEGMENT, "canAddItems"], true);
    set_1.default(referencePointConfigured, uiConfig_1.UICONFIG, setTreemapBucketWarningMessages(referencePointConfigured, intl));
    set_1.default(referencePointConfigured, [uiConfig_1.UICONFIG, bucket_1.BUCKETS, sdk_ui_1.BucketNames.MEASURES, "icon"], bucket_title_measures_svg_1.default);
    set_1.default(referencePointConfigured, [uiConfig_1.UICONFIG, bucket_1.BUCKETS, sdk_ui_1.BucketNames.VIEW, "icon"], bucket_title_view_svg_1.default);
    set_1.default(referencePointConfigured, [uiConfig_1.UICONFIG, bucket_1.BUCKETS, sdk_ui_1.BucketNames.SEGMENT, "icon"], bucket_title_segment_svg_1.default);
    return referencePointConfigured;
}
exports.setTreemapUiConfig = setTreemapUiConfig;
//# sourceMappingURL=treemapUiConfigHelper.js.map